// export const api = "http://localhost:3001";
export const api = "https://iconmarketing.shop";
